import gql from 'graphql-tag'

export interface PwaFormField {
  code: string
  value: string
}

export const processPwaForm = gql`
  mutation processPwaForm(
    $form_fields: [PwaFormField]
    $form_id: String!
  ) {
      processPwaForm(
      input: {
        form_id: $form_id
        form_fields: $form_fields
      }
    ) {
      success
      message
      errors {
          field
          message
      }
    }
  }
`
